import { render } from "./TheImpressumView.vue?vue&type=template&id=d0b86162&scoped=true"
import script from "./TheImpressumView.vue?vue&type=script&lang=js"
export * from "./TheImpressumView.vue?vue&type=script&lang=js"

import "./TheImpressumView.vue?vue&type=style&index=0&id=d0b86162&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0b86162"]])

export default __exports__